import { SearchLocation } from "@/interfaces/property.interface";

export const POPULAR_SEARCH_LOCATIONS: Array<SearchLocation> = [
  {
    level: 1,
    locationType: "COMMUNITY",
    name: "Dubai Marina",
    slug: "dubai-marina",
    fullSlug: "dubai/dubai-marina",
    polygon: null,
    centralPoint: {
      type: "Point",
      coordinates: [55.14041, 25.078367],
    },
    path: "1.50",
    pathName: "Dubai",
    description: null,
    faq: null,
    metadata: null,
    label: "Dubai Marina",
    value: "dubai/dubai-marina",
  },
  {
    label: "Downtown Dubai",
    centralPoint: {
      coordinates: [25.194985, 55.278414],
      type: "Point",
    },
    level: 1,
    locationType: "COMMUNITY",
    name: "Downtown Dubai",
    slug: "downtown-dubai",
    fullSlug: "dubai/downtown-dubai",
    value: "dubai/downtown-dubai",
    polygon: null,
    path: "1.41",
    pathName: "Dubai",
    description: null,
    faq: null,
    metadata: null,
  },
  {
    label: "Business Bay",
    fullSlug: "dubai/business-bay",
    value: "dubai/business-bay",
    slug: "business-bay",
    centralPoint: {
      coordinates: [25.18739, 55.263829],
      type: "Point",
    },
    level: 1,
    locationType: "COMMUNITY",
    name: "Business Bay",
    polygon: null,
    path: "1.36",
    pathName: "Dubai",
    description: null,
    faq: null,
    metadata: null,
  },
  {
    label: "Palm Jumeirah",
    fullSlug: "dubai/palm-jumeirah",
    value: "dubai/palm-jumeirah",
    slug: "palm-jumeirah",
    centralPoint: {
      coordinates: [25.114929, 55.137455],
      type: "Point",
    },
    level: 1,
    locationType: "COMMUNITY",
    name: "Palm Jumeirah",
    polygon: null,
    path: "1.86",
    pathName: "Dubai",
    description: null,
    faq: null,
    metadata: null,
  },
  {
    label: "Jumeirah Village Circle",
    fullSlug: "dubai/jumeirah-village-circle",
    value: "dubai/jumeirah-village-circle",
    slug: "jumeirah-village-circle",
    centralPoint: {
      coordinates: [25.056388, 55.208121],
      type: "Point",
    },
    level: 1,
    locationType: "COMMUNITY",
    name: "Jumeirah Village Circle",
    polygon: null,
    path: "1.73",
    pathName: "Dubai",
    description: null,
    faq: null,
    metadata: null,
  },
  {
    label: "Jumeirah Lake Towers",
    fullSlug: "dubai/jumeirah-lake-towers",
    value: "dubai/jumeirah-lake-towers",
    slug: "jumeirah-lake-towers",
    centralPoint: {
      coordinates: [25.075226, 55.146376],
      type: "Point",
    },
    level: 1,
    locationType: "COMMUNITY",
    name: "Jumeirah Lake Towers",
    polygon: null,
    path: "1.71",
    pathName: "Dubai",
    description: null,
    faq: null,
    metadata: null,
  },
];
